import {Activity} from '../activity/activity';
import {Attachment} from '../attachment/attachment';
import {FaultData} from './fault-data';
import {ChangeStatusEnum} from '@docma-mm-core/model/change-state/change-status.enum';
import {MmModel} from '@docma-mm-core/model/mm.model';
import {MmSyncableModel} from '@docma-mm-core/model/mm-syncable.model';
import {Project} from '@docma-mm-core/project/project';
import {Coordinate} from '@docma-mm-core/plan/plan';
import {BehaviorSubject} from 'rxjs';
import {Group} from '@docma-mm-core/group/group';
import { BpPin } from '../../bp-common/models/bp-pin';


export class Fault extends MmSyncableModel<FaultData>  {

  private _attachments = new BehaviorSubject<Array<Attachment>>([]);
  public attachments$ = this._attachments.asObservable();

  private _activities = new BehaviorSubject<Array<Activity>>([]);
  public activities$ = this._activities.asObservable();

  private _groups = new BehaviorSubject<Array<Group>>([]);
  public groups$ = this._groups.asObservable();

  downloaded = false;

  constructor(init?: Partial<Fault>) {
    super(init);
    if (!this.uid && init && init.uid) {
      this.uid = init.uid;
    }
    if (init) {
      this.downloaded = !!init.downloaded;
      if (init.activities && init.activities.length > 0) {
        this.activities = [];
        this.addActivities(init.activities.map(a => new Activity(a)));
      }
      if (init.attachments && init.attachments.length > 0) {
        this.attachments = [];
        init.attachments.map(a => new Attachment(a))
          .forEach(a => this.addAttachment(a) );
      }
    }
  }

  public GetGroups(activities: Array<Activity>) : { [uid: string]: Group } {
    return activities
      .reduce((acc, curr) => {
        if(curr.group) {
          const uid = curr.group.uid;

          if (acc[uid] == null) {
            let grp = new Group();
            grp.id = curr.group.id;
            grp.uid = curr.group.uid;

            acc[uid] = [];
            acc[uid].push(grp);
          }
        }
        return acc;
      }, {});
  }

  get isNew(): boolean {
    return !this.id;
  }

  get attachments(): Attachment[] {
    return this._attachments.value;
  }
  set attachments(v: Attachment[]) {
    this._attachments.next(v);
  }

  get activities(): Activity[] {
    return this._activities.value;
  }
  set activities(v: Activity[]) {
    this._activities.next(v);
  }

  // get groups(): Group[] {
  //   return this._groups.value;
  // }
  // set groups(v: Group[]) {
  //   this._groups.next(v);
  // }

  addActivity(activity: Activity) {

    if (!this.activities || this.activities.length === 0 || !this.activities.find(a => a == activity)) {
      const newArray = [...this.activities || []];
      activity.fault = {id: this.id, uid: this.uid};
      newArray.push(activity);
      this.activities = newArray;
      // this.initGroups();
    }
  }

  addActivities(activities: Activity[]) {

    if (!this.activities || this.activities.length === 0) {
      const newArray = [...this.activities || []];
      for (const activity of activities) {
        if (!this.activities.find(a => a === activity)) {
          activity.fault = { id: this.id, uid: this.uid };
          newArray.push(activity);
        }
      }
      this.activities = newArray;
      // this.initGroups();
    }
  }

  // initGroups() {
  //   let groupsDict = this.GetGroups(this.activities);
  //     if (groupsDict) {
  //       this.groups = []
  //       this.groups =  Object.values(groupsDict);
  //     }
  // }

  removeActivity(activity: Activity) {
    if (this.activities && this.activities.length > 0 ) {
      const index = this.activities.findIndex(a => a == activity);
      if (index >= 0) {
        const newArray = [...this.activities ];
        newArray.splice(index, 1);
        this.activities = newArray;
        // this.initGroups();
      }
    }
  }

  removeActivities(activities: Activity[]) {
    if (this.activities && this.activities.length > 0 ) {
      const newArray = [...this.activities ];
      for (const activity of activities) {
        const index = this.activities.findIndex(a => a === activity);
        if (index >= 0) {
          newArray.splice(index, 1);
        }
      }
      this.activities = newArray;
      // this.initGroups();
    }
  }

  addAttachment(attachment: Attachment) {

    if (!this.attachments || this.attachments.length === 0 || !this.attachments.find(a => a === attachment)) {
      const newArray = [...this.attachments || []];
      attachment.fault = { id: this.id, uid: this.uid };
      newArray.push(attachment);
      this.attachments = newArray;
    }
  }

  removeAttachment(attachment: Attachment) {

    if (this.attachments && this.attachments.length > 0 ) {
      const index = this.attachments.findIndex(a => a === attachment);
      if (index >= 0) {
        const newAttachments = [...this.attachments ];
        newAttachments.splice(index, 1);
        this.attachments = newAttachments;
      }
    }
  }

  removeAttachmentFromActivity(attachment: Attachment, activity: Activity) {
    if (this.activities && this.activities.length > 0 ) {
      const activityIndex = this.activities.findIndex(a => a === activity);
      const attachmentIndex = activity.attachments.findIndex(a => a === attachment);

      const newAttachments = [...activity.attachments ];
      newAttachments.splice(attachmentIndex, 1);
      activity.attachments = newAttachments;

      const newActivities = [...this.activities];
      newActivities[activityIndex] = activity;
      this.activities = newActivities;
    }
  }

  hasAnyChanges(): boolean {
    if (this.changeState && this.changeState.status !== ChangeStatusEnum.NotChanged) {
      return true;
    }
    if (this.attachments) {
      for (const a of this.attachments) {
        if (a.changeState && a.changeState.status !== ChangeStatusEnum.NotChanged) {
          return true;
        }
      }
    }
    if (this.activities) {
      for (const a of this.activities) {
        if (a.changeState && a.changeState.status !== ChangeStatusEnum.NotChanged) {
          return true;
        }
        if (a.attachments) {
          for (const aa of a.attachments) {
            if (aa.changeState && aa.changeState.status !== ChangeStatusEnum.NotChanged) {
              return true;
            }
          }
        }
      }
    }

  }
}

export class LayoutFault extends MmModel<any>  {
  isLocked?: boolean;

  constructor(init?: Partial<LayoutFault>) {
    super(init);
    this.isLocked = init.isLocked;
  }
}

export class ViewFault extends Fault {

  constructor(init?: Partial<ViewFault>) {
    super(init);
    if (init) {
      this.project = init.project;
      this.isChecked = init.isChecked;
      this.unsavedNew =  init.unsavedNew;
      this.pin = init.pin;
      this.uid = init.uid;
      this.data.IsLocked = init.isLocked;
      this.data.Attribute = (init?.attributeId ? { Id: init.attributeId } : undefined);
      this.pinText = init?.pinText;
    }
    this.layoutState = init && init.layoutState || new MmModel();

    // this.syncState$.pipe(untilDestroyed(this))
    //   .subscribe(x => {
    //     console.debug("syncState$" + JSON.stringify(x.status));
    //   });

    // this.loadState$.pipe(untilDestroyed(this))
    //   .subscribe(x => {
    //     console.debug("loadState$" + JSON.stringify(x.status));
    //   });

    // this.changeState$.pipe(untilDestroyed(this))
    //   .subscribe(x => {
    //     console.debug("changeState$" + JSON.stringify(x.status));
    //   });
  }

  isLocked = false;
  layoutState: MmModel<any> ;
  pin: Coordinate;
  bpPin: BpPin;
  isChecked = false;
  unsavedNew = false;
  project: Project;
  attributeId?: number;
  pinText?: string;

  firstLoad?: boolean;

  get identifier() {
    return this.id || this.uid;
  }
}

